import React, { useCallback, useEffect } from 'react';
import { Button } from '../../components/Button/Button';
import cartImage from '../../assets/images/cart.png';

import './PaymentSuccessView.css';
import { useLanguage } from '../../locale/useLanguage';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../routes/types';
import { useQueryParams } from '../../hooks/useQueryParams';
import { GaEvent, pushEvent } from '../../helpers/googleAnalytics';

type PaymentSuccessViewProps = {};

export const PaymentSuccessView: React.FC<PaymentSuccessViewProps> = () => {
  const [t] = useLanguage();
  const history = useHistory();
  const queryParams = useQueryParams();

  const transactionCode = queryParams.get('transactionId');
  const products = queryParams.get('products');
  const price = queryParams.get('price');
  const shipperId = queryParams.get('shipperId');
  const shipperName = queryParams.get('shipperName');
  const territoryId = queryParams.get('territoryId');
  const shipperOrderCode = queryParams.get('shipperOrderCode');
  const orderStatus = queryParams.get('orderStatus');

  useEffect(() => {
    if (!transactionCode) {
      history.replace(Routes.Home);
    }
  }, [history, transactionCode]);

  useEffect(() => {
    if (
      products &&
      price &&
      shipperId &&
      territoryId &&
      shipperOrderCode &&
      orderStatus &&
      shipperName
    )
      pushEvent(GaEvent.PurchaseSuccess, {
        name: GaEvent.PurchaseSuccess,
        orderStatus: orderStatus,
        price,
        products,
        shipperId,
        shipperName,
        shipperOrderCode,
        territoryId,
      });
  }, [
    orderStatus,
    price,
    products,
    shipperId,
    shipperName,
    shipperOrderCode,
    territoryId,
  ]);

  const goToTracking = useCallback(() => {
    history.push(Routes.Home);
  }, [history]);

  const goToOrders = useCallback(() => {
    history.push(Routes.Orders);
  }, [history]);

  return (
    <div className="payment-success--container">
      <div className="payment-success--body">
        <div className="payment-success--content">
          <img className="payment-success--image" src={cartImage} />
          <h3 className="payment-success--title">
            {t('paymentSuccess.title')}
          </h3>
          <p className="payment-success--description">
            {t('paymentSuccess.description')}
          </p>
          <p className="payment-success--description payment-success--transaction-code">
            {t('paymentSuccess.transactionCode')}
          </p>
          <p className="payment-success--description">{transactionCode}</p>
        </div>
        <div>
          <Button
            onClick={goToTracking}
            isWhite
            label={t('paymentSuccess.trackOrder')}
          />
          <div className="payment-success--button-container">
            <Button
              onClick={goToOrders}
              label={t('paymentSuccess.yourOrders')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
